require('./frontend.base.js');
require('./frontend.functions.js');

$(document).ready(function() {
    // remove loading state and first paint styles
    $('body').removeClass('loading');
    $('style#firstPaint').remove();

    /* ↓ add custom JS here IF you must (but seriously - don't 🙏) ↓ */
});